var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "image"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 950",
    opacity: 0.4,
    d: "M16.7285 5.81884L19.1094 7.40612C19.6658 7.77706 20 8.40152 20 9.07023V11.9999C20 14.209 18.2091 15.9999 16 15.9999H4C1.79086 15.9999 0 14.209 0 11.9999V9.86837C0 9.06968 0.890145 8.59329 1.5547 9.03632L3.27153 10.1809C4.85802 11.2385 6.9705 11.0294 8.31875 9.6811L11.6812 6.31861C13.0295 4.97036 15.142 4.76118 16.7285 5.81884Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 396",
    cx: 5,
    cy: 3,
    r: 3,
    fill: "#AFAFAF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefault);
export default __webpack_public_path__ + "static/media/image-default.9bc9ffda.svg";
export { ForwardRef as ReactComponent };